import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { constants } from 'helpers'

const initialState = {
    status: constants.SHOW_NAVBAR
}
const navbarSlice = createSlice({
    name: 'navbar',
    initialState,
    reducers: {
        processNavbar: (state, action: PayloadAction<string>) => {
            state.status = action.payload
        }
    }
})

export const { processNavbar } = navbarSlice.actions
export const navbarReducer = navbarSlice.reducer
